import { Component, Inject, ViewChild }     from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef }   from '@angular/material/dialog';
import { FormGeneratorNxtComponent }       from '@cs/components/form-generator-nxt';
import { FormDataDescribed }               from '@cs/core';

export interface ActionFormDialogData {
	/** Server-provided form definition (FormDataDescribed) */
	formData: FormDataDescribed<any>;
	/** Dialog header title */
	title?: string;
	/** Label for the confirm button (defaults to 'OK') */
	confirmLabel?: string;
}

export interface ActionFormDialogResult {
	confirmed: boolean;
	/** Raw form values from FormGeneratorNxt */
	values: { [key: string]: any };
}

@Component({
			   selector:    'cs-action-form-dialog',
			   templateUrl: './action-form-dialog.component.html',
			   standalone:  false
		   })
export class ActionFormDialogComponent {

	@ViewChild('formRef', {static: false}) formRef: FormGeneratorNxtComponent<any>;

	constructor(
		public dialogRef: MatDialogRef<ActionFormDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: ActionFormDialogData
	) {}

	get isValid(): boolean {
		return this.formRef?.form?.formGroup?.valid ?? false;
	}

	onConfirm(): void {
		if (!this.isValid) return;
		this.dialogRef.close({
								  confirmed: true,
								  values:    this.formRef.getFormData()
							  } as ActionFormDialogResult);
	}

	onCancel(): void {
		this.dialogRef.close(null);
	}
}
